exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".squareGiftCard-submitButton{margin-top:16px}.squareGiftCard-sq-fieldset{background-color:var(--input-background-color)}.squareGiftCard-squareInputStyles{background-color:transparent;color:var(--input-text-color);font-size:16px;line-height:24px;padding:16px}.squareGiftCard-formContainer{margin:20px 0}\n", ""]);

// exports
